import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CareerManagerGuard implements CanActivate {
  constructor(
    private keycloakAngular: KeycloakService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const roles = this.keycloakAngular.getUserRoles();
    const allowed = roles.includes('ROLE_ADMIN') || roles.includes('ROLE_ERH');

    if (!allowed) {
      this.router.navigate(['/dashboard']);
    }

    return allowed;
  }
}